module.exports = __webpack_public_path__ + "static/media/orange_nebula_LF.00569d4c.png";